import script from "./AlertDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./AlertDetailModal.vue?vue&type=style&index=0&id=577f83f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577f83f7"]])

export default __exports__